/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const fetchDescription = async (url: string, signal: AbortSignal) => {
  const text = await (await fetch(url, { signal })).text();

  const section = text.indexOf(`<section data-cy="text-block-container"`);

  const pOpen = section + text.slice(section).indexOf('<p');

  const pClose = pOpen + text.slice(pOpen).indexOf('</p>') + '</p>'.length;

  const p = text.slice(pOpen, pClose);

  const div = document.createElement('div');

  div.innerHTML = p;

  return div.innerText;
};
